import { SHARED_DEPENDENCIES_GLOBAL_NAME } from '../../constants.js';

const getSharedDependenciesFromWindow = () => typeof globalThis[SHARED_DEPENDENCIES_GLOBAL_NAME] !== 'undefined' ? globalThis[SHARED_DEPENDENCIES_GLOBAL_NAME] : {};
const addSharedDepepndenciesToWindow = (preloadedSharedDependencies) => {
    const existingLoadedSharedDependencies = getSharedDependenciesFromWindow();
    window[SHARED_DEPENDENCIES_GLOBAL_NAME] = { ...existingLoadedSharedDependencies, ...preloadedSharedDependencies };
};
class GlobalSharedDependenciesManager {
    constructor() {
        const existingLoadedSharedDependencies = getSharedDependenciesFromWindow();
        this.globalDependencies = new Map();
        Object.keys(existingLoadedSharedDependencies).forEach(globalName => {
            // even though the existingLoadedSharedDependencies contains the exact loaded version - we don't need it here.
            // We only care that the version is loaded.
            this.globalDependencies.set(globalName, { loadFrom: 'preloaded-from-host', loadPromise: Promise.resolve() });
        });
    }
    ensureDependencyLoadPromise(globalName, load) {
        const globalDep = this.globalDependencies.get(globalName);
        if (!globalDep) {
            return null;
        }
        globalDep.loadPromise || (globalDep.loadPromise = load());
        return globalDep.loadPromise;
    }
    getDependencyLoadPromise(globalName) {
        const globalDep = this.globalDependencies.get(globalName);
        if (!globalDep) {
            return null;
        }
        return globalDep.loadPromise || null;
    }
    addKnownDependencies(globalDeps) {
        globalDeps.forEach(({ globalName, url }) => {
            if (this.globalDependencies.has(globalName)) {
                // this global dependency is already known - we won't override its state
                return;
            }
            this.globalDependencies.set(globalName, { loadFrom: url, loadPromise: null });
        });
    }
    getUrl(globalDep) {
        const details = this.globalDependencies.get(globalDep);
        if (!details) {
            throw new Error(`Attempted getting URL to load of a missing global dependency: ${globalDep}`);
        }
        return details.loadFrom;
    }
}

export { addSharedDepepndenciesToWindow, GlobalSharedDependenciesManager as default, getSharedDependenciesFromWindow };
